import { JobActionTypes, All } from '../actions/job.actions';
import { Job, RequestStatus, PageBackground } from '@app/shared';

// define State interface
export interface State {
  // is a user authenticated?
  selectedJob: Job | null;
  // if authenticated, there should be a user object
  jobs: Job[] | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  isEditing: boolean | null;
  pauseState: boolean | null;
  actionType:String | null;
  preferences:any[] | null;
  pageBackgrounds:PageBackground[] | null;
}

// define initial state
export const initialState: State = {

  selectedJob: null,
  jobs: null,
  errorStatus: null,
  successStatus: null,
  isEditing: false,
  pauseState: false,
  actionType: null,
  preferences:null,
  pageBackgrounds:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case JobActionTypes.GET_JOBS_SUCCESS: {
      return {
        ...state,
        selectedJob: null,
        jobs: action.payload.jobs,
        errorStatus:null,
        actionType:action.type,
        successStatus:null,
      };
    }
    case JobActionTypes.GET_JOB_PAGES_SUCCESS: {
      return {
        ...state,
        //selectedJob: selectedJob,
        errorStatus:null,
        pauseState:action.payload.pauseState,
        actionType:action.type,
        successStatus:null,
      };
    }
    case JobActionTypes.GET_PREFERENCES_SUCCESS: {	
      return {	
        ...state,		
        actionType:action.type,	
        preferences: action.payload.preferences,
      }	
    }
    case JobActionTypes.SWAP_SEGMENTS_SUCCESS:
    case JobActionTypes.ADD_PAGES_TO_REGION_SUCCESS: {
      return {
        ...state,
        //selectedJob: selectedJob,
        errorStatus:null,
        pauseState:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        pauseState:null,
        successStatus:action.payload.successStatus,
        actionType:action.type,
      };
    }
    case JobActionTypes.SET_JOB: {
      return {
        ...state,
        selectedJob: action.payload.job,
        actionType:action.type,
        successStatus:null,
      };
    }
    case JobActionTypes.DELETE_JOB_SUCCESS:
    case JobActionTypes.SET_JOB_LOCK_SUCCESS:
    case JobActionTypes.COPY_JOB_SUCCESS:
    case JobActionTypes.COPY_FULL_JOB_SUCCESS:
    case JobActionTypes.UPDATE_JOB_SUCCESS: {
      return {
        ...state,
        selectedJob: action.payload.job,
        actionType:action.type,
        successStatus:action.payload.successStatus,
      };
    }
    case JobActionTypes.CREATE_JOB:
    case JobActionTypes.EDIT_JOB: {
      return {
        ...state,
        selectedJob: action.payload.job,
        isEditing: action.payload.isEditing,
        actionType:action.type,
        successStatus:null,
      };
    }
    case JobActionTypes.DELETE_JOB_FAILURE:
    case JobActionTypes.SWAP_SEGMENTS_FAILURE:
    case JobActionTypes.SET_JOB_LOCK_FAILURE:
    case JobActionTypes.COPY_JOB_FAILURE:
    case JobActionTypes.COPY_FULL_JOB_FAILURE:
    case JobActionTypes.UPDATE_JOB_FAILURE:
    case JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_FAILURE:
    case JobActionTypes.SET_JOB_FAILURE:
    case JobActionTypes.GET_JOBS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.errorStatus,
        actionType:action.type,
        successStatus:null,
      };
    }
    case JobActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        pageBackgrounds:action.payload.pageBackgrounds,
      };
    }
    case JobActionTypes.CLEAR_JOB_STATE: {
      console.log('clear job status')
      return {
        ...state,
        selectedJob: null,
        jobs: null,
        errorStatus: null,
        successStatus: null,
        isEditing: false,
        pauseState: false,
        actionType: null,
      };
    }
    default: {
      return {
        ...state,
        actionType:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/job.reducer.ts